/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { IconEnd } from "../../icons/IconEnd";
import "./style.css";

export const SearchButton = ({ className }) => {
  return (
    <div className={`search-button ${className}`}>
      <IconEnd className="icon-end" />
    </div>
  );
};
